var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-data-table',{staticClass:"elevation-0",attrs:{"dense":"","headers":_vm.getHeaders,"items":_vm.getItems,"items-per-page":10,"loading":_vm.loading,"footer-props":{
      prevIcon: 'fa fa-angle-left',
      nextIcon: 'fa fa-angle-right',
      itemsPerPageOptions: [5, 10, 15],
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }